"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var react_components_1 = require("@lws/react-components");

var renderers_1 = require("../../utils/renderers");

exports.CustomTeaserText = function (_a) {
  var label = _a.label,
      text = _a.text;

  var _b;

  return react_1["default"].createElement(react_1["default"].Fragment, null, label && react_1["default"].createElement(components_1.Paragraph, {
    size: (_b = components_1.Paragraph.Sizes) === null || _b === void 0 ? void 0 : _b.HELPER
  }, label), react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
    content: text,
    options: renderers_1.withFootnotesAndCustomBlocks
  }));
};